const CHAT_ROUTE = '/chat-messages/list'

export { CHAT_ROUTE }
